import { getNotifications } from "@/utils/task";
import { useQuery } from "@tanstack/react-query";

export function useNotifications() {
      const { data: notifications, isLoading : isNotificationFetching } = useQuery({
    queryKey: ["notifications"],
    queryFn: getNotifications,
    cacheTime: 5 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
  });

  return {notifications, isNotificationFetching}
}